/*
 * @Description: file content
 * @Author: ljrong
 * @Date: 2024-03-22 21:34:00
 * @LastEditors: ljrong jinrong.li@beautydata.ai
 * @LastEditTime: 2024-07-25 15:53:17
 */
import { post } from '@/utils/request'

import type * as KnowledegFolderType from '@/types/knowledge/folder'

/**
 * 列表查看 带概要，支持指定排序，分页
 */
export function getKnowledegFolderList(data: KnowledegFolderType.KnowlegeFolderParams) {
  const defaultParams = {
    page: 1,
    pageSize: 10,
    // sort: KnowlegeLibSortType.UpdateTime,
    keyword: '',
    ...data,
  }
  return post<KnowledegFolderType.KnowlegeFolder[]>({
    url: '/assistant/lib/dir/page',
    data: defaultParams,
  })
}

export function getKnowledegFolderFileCount(data: KnowledegFolderType.KnowlegeFolderParams) {
  const defaultParams = {
    page: 1,
    pageSize: 10,
    // sort: KnowlegeLibSortType.UpdateTime,
    keyword: '',
    ...data,
  }
  return post<KnowledegFolderType.KnowlegeFolder[]>({
    url: '/assistant/lib/dir/getFileTotal',
    data: defaultParams,
  })
}

/**
 * 文件夹重名检测 重名直接提示
 */
export function checkFolderName(data: KnowledegFolderType.CreateFolderParams) {
  return post<number>({
    url: '/assistant/lib/dir/checkName',
    data,
  })
}

/**
 * 创建文件夹 重名抛异常，应该先调用重名检测
 */
export function createFolder(data: KnowledegFolderType.CreateFolderParams) {
  return post<number>({
    url: '/assistant/lib/dir/create',
    data,
  })
}

/**
 * 删除文件夹 支持批量操作
 */
export function deleteFolder(data: { dirIds: number[]; enterpriseId: number; knowledgeBaseId: number }) {
  return post<{ model: boolean }>({
    url: '/assistant/lib/dir/remove',
    data,
  })
}

/**
 * 更新文件夹 重命名 / 修改备注
 */
export function updateFolder(data: KnowledegFolderType.UpdateFolderParams) {
  return post<{ model: boolean }>({
    url: '/assistant/lib/dir/update',
    data,
  })
}

/**
 * 文件夹摘要查看 备用方案 单文件夹下，引用过多，不宜一次性全部关联查询返回
 */
export function getFolderDigest(data: KnowledegFolderType.FolderDigestParams) {
  return post<KnowledegFolderType.FolderDigestModel>({
    url: '/assistant/lib/dir/getDigest',
    data,
  })
}
